import React from 'react';
import { assets } from '../data/landing';

/**
 * Official brand photo, used exactly as provided.
 * The asset already carries its own copy — never add text, caption or overlay.
 */
export function BrandPhoto() {
  return <section aria-label="Convertí tu amor por los perros en tu propio servicio" className="bg-cream" data-id="element-18" data-mp="paqppihnh57c">
      <div className="mx-auto max-w-xl px-5 py-10 sm:px-8 sm:py-14" data-id="element-19" data-mp="u9bqbj0tdqwb">
        <img src={assets.brandPhoto} alt="Mujer sonriendo mientras pasea a un golden retriever por la vereda" className="block h-auto w-full rounded-[1.75rem] shadow-card" loading="lazy" decoding="async" data-id="element-20" data-mp="gac0i81kf5yk" />
      </div>
    </section>;
}